import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import "./flightLocations.css";

const FlightTrainingLocation = () => {
  const locations = [
    { name: "EUROPE", students: "30+", image: `${process.env.PUBLIC_URL}/assets/img/flight/MXP.jpg` },
    { name: "CANADA", students: "40+", image: `${process.env.PUBLIC_URL}/assets/img/flight/canada.jpg` },
    { name: "SOUTH AFRICA", students: "300+", image: `${process.env.PUBLIC_URL}/assets/img/flight/South-Africa.jpg` },
    { name: "PHILIPPINES", students: "120+", image: `${process.env.PUBLIC_URL}/assets/img/flight/phipines-768x754.jpg` },
    { name: "AUSTRALIA", students: "15+", image: `${process.env.PUBLIC_URL}/assets/img/flight/Australia.jpg` },
  ];

  return (
   <section className="flight-locations" id="flightTraining">
      <div className="container">
        <h2 className="flight-title">Flight Training Location</h2>

    <Swiper
  modules={[Autoplay, Pagination]}
  centeredSlides={true}
  loop={true}
  slidesPerView={3}
  spaceBetween={-100}
  initialSlide={3}    
  autoplay={{ delay: 2000 }}
  pagination={{ clickable: true }}
  className="locations-slider"
>
 

          {locations.map((loc, i) => (
            <SwiperSlide key={i}>
              <div className="location-card">
                <img src={loc.image} alt={loc.name} />

                <div className="card-badge">
                  Flying School Overview
                </div>

                <div className="card-overlay">
                  <h3>{loc.name}</h3>
                  <p>Students trained: {loc.students}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default FlightTrainingLocation;
